import { Course, Instructor } from "../../../../domain/entities/entities";
import http from "../../http/index";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";
import { formatSearchQuery } from "../../../presentation/components/mixins";
import InstructorInterface from "./instructor_interface";
import { Order } from "domain/entities/order";
import { ListResponse } from "domain/entities/shop/product/listResponse";

class InstructorRepository implements InstructorInterface {
  listBySearchInstructors(search: string): Promise<Instructor[]> {
    return wrapErrorHandler<Instructor[]>(async () => {
      const response = await http.get(
        `/api/decola/instructors/globalSearch?search=${formatSearchQuery(
          search
        )}`
      );
      return response.data;
    });
  }

  getCoursesByInstructors(
    order: Order,
    instructorId: number
  ): Promise<ListResponse<Course[]>> {
    return wrapErrorHandler<ListResponse<Course[]>>(async () => {
      const response = await http.get(
        `/api/decola/list/course/instructors/${instructorId}`,
        {
          params: {
            page: order.page,
            limit: 20,
          },
        }
      );
      return response.data;
    });
  }
}

export default new InstructorRepository() as InstructorInterface;
